import React from "react";
import { HelpCircle, LockKeyhole, Rocket, Upload } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { SurfaceCard } from "../components/designSystem";

function FAQ() {
  const faqs = [
    {
      q: "Is my trading data secure?",
      a: "Your account data is authenticated and scoped to your user account. The platform is being hardened further with stronger validation, auditability, and production-grade operational safeguards.",
      icon: LockKeyhole,
    },
    {
      q: "Can I use MekEdge for free?",
      a: "Yes. The free plan covers core journaling and basic analytics, while paid plans unlock deeper review workflows, exports, messaging, and team features.",
      icon: Rocket,
    },
    {
      q: "Do you support imports from MT4/MT5?",
      a: "Not yet. CSV and platform import workflows are on the roadmap because serious traders need a clean way to migrate and backfill journal history.",
      icon: Upload,
    },
  ];

  return (
    <div className="min-h-screen bg-[#f3efe7] text-slate-950 dark:bg-[linear-gradient(180deg,_#020617_0%,_#111827_45%,_#0f172a_100%)] dark:text-slate-100">
      <PageHeader 
        title="Frequently Asked Questions" 
        subtitle="Clear answers to the questions traders usually ask before they trust a journal with real trading data."
        eyebrow="FAQ"
      />
      <div className="mx-auto max-w-5xl px-6 py-16 lg:px-10">
        <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white/70 px-4 py-2 text-xs font-semibold uppercase tracking-[0.28em] text-slate-500 backdrop-blur dark:border-gray-700 dark:bg-gray-900/70 dark:text-slate-300">
          <HelpCircle className="h-3.5 w-3.5" />
          Product clarity
        </div>
        <div className="space-y-5">
          {faqs.map((faq) => {
            const Icon = faq.icon;
            return (
              <SurfaceCard key={faq.q} className="bg-white dark:bg-gray-900">
                <div className="flex items-start gap-4">
                  <div className="rounded-2xl bg-[#f3efe7] p-3 text-slate-900 dark:bg-gray-800 dark:text-white">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-slate-950 dark:text-white">{faq.q}</h2>
                    <p className="mt-3 text-sm leading-7 text-slate-600 dark:text-slate-300">{faq.a}</p>
                  </div>
                </div>
              </SurfaceCard>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default FAQ;